/** Backend API controller route segments for standard CRUD endpoints. */
export const ApiControllers = {
  Purity: 'Purity',
  Customer: 'Customer',
  Supplier: 'Supplier',
  Salesman: 'Salesman',
  Item: 'Item',
  Size: 'Size',
  AppModule: 'AppModule',
  Category: 'Category',
  User: 'User',
  State: 'State',
  LabelGeneration: 'LabelGeneration',
  Sales: 'Sales',
  Purchase: 'Purchase',
  CompanyDetails: 'CompanyDetails',
  AccountGroup: 'AccountGroup',
  AccountPrimaryGroup: 'AccountPrimaryGroup',
  AccountNature: 'AccountNature',
  AccountStockItem: 'AccountStockItem',
  AccountStockGroup: 'AccountStockGroup',
  AccountUnit: 'AccountUnit',
  Auth: 'Auth',
} as const;

export type ApiControllerName =
  (typeof ApiControllers)[keyof typeof ApiControllers];
